import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { LMSDataService } from 'lms-api';

@Component({
  selector: 'app-related-course-list',
  templateUrl: './related-course-list.component.html',
  styleUrls: ['./related-course-list.component.scss']
})
export class RelatedCourseListComponent implements OnInit {
  @Input() course;
  public relatedCourses: any[];

  constructor(private lmsDataService: LMSDataService) {
    this.relatedCourses = [];
  }

  ngOnInit() {
    this.populateRelatedCourses();
  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes.course) {
      this.populateRelatedCourses();
    }
  }

  private populateRelatedCourses() {
    this.relatedCourses = [];
    if (this.course.related_courses != null) {
      for (let courseId of this.course.related_courses) {
        this.lmsDataService.GetCourse(courseId).subscribe(course => {
          if (this.relatedCourses.filter(rc => rc.alias == course.alias).length == 0) {
            this.relatedCourses.push({
              alias: course.alias,
              title: course.title
            });
          }
        });
      }
    }
  }
}